import {BaseElement} from "/@back@/commons/basis.js";
import {IItemUiEnv} from "/@back@/wsp/views/itemMain.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {IView} from "/@lib@/commons/views.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {JSrcFields} from "/@lib@/wsp/src.js";
import {ORemoteViewInit, RemoteView} from "/@back@/wsp/widgets/remoteView.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";

/**
 * View d'une res remote d'un item sans la nouvelle approche JRemoteResDesc à partir sc6.1
 *  TODOsc7 à suppr ?
 *
 * Config attributes:
 */
export interface ItemRemote extends BaseElement {
	initialize(init: OItemRemoteInit): this;
}

export interface OItemRemoteInit extends ORemoteViewInit {
	reg?: IReg<IItemUiEnv>
}

export class ItemRemote extends BaseElement implements IView {
	reg: IReg<IItemUiEnv>;
	remView: RemoteView;

	_initialize(init: OItemRemoteInit) {
		this.reg = this.findReg(init);
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		this.remView = sr.appendChild(<RemoteView style="flex:1" î={init}/>) as RemoteView;
		this.remView.wsp = this.reg.env.wsp;
		this.remView.fields = this.reg.env.longDesc;
		this.reg.env.longDescChange.add((ldNew: JSrcFields) => this.remView.fields = ldNew);
	}
}

REG.reg.registerSkin("wsp-item-remote", 1, /* language=CSS */ `
	:host {
		overflow: auto;
		display: flex;
	}
`);

customElements.define("wsp-item-remote", ItemRemote);
